import { AppData, Log, Router, Settings, Utils } from '@lightningjs/sdk'
import { initSettings } from '@lightningjs/sdk/src/Settings'
import { initUtils} from '@lightningjs/sdk/src/Utils'
import MainGrid from './pages/main-grid-screen'
import SelectScreen from './pages/select-screen'
import TwoRowSelectScreen from './pages/two-row-select-screen'
import Splash from './pages/splash'
import SearchScreen from "./pages/search-screen";
import MLPGrid from './pages/mlp-grid-screen';
import { AppSetup } from './lib/app-setup';
import { GRIDTYPE } from './lib/enum';
import VideoScreenLive from './pages/video-screen-live';
import CCSetting from './pages/cc-setting-screen';  
import SettingsScreen from './pages/settings-screen'
import { Helper } from './lib/helper'
import { getCdnPath } from './lib/models/data-service'
import { ApplicationInstance } from '@lightningjs/sdk/src/Launch'
import VideoScreenNew from './pages/video-screen-new';

export const routes: Router.Config = {
  boot: (qs) => {
    const { platform, appConfig } = AppData as AppSetup
    return new Promise(bootResolve=>{
      const promise = new Promise(resolve=>{
          getCdnPath().then((resp)=>{
          Log.info('Get Cdn Path - ', resp)
          if(resp && resp.data && resp.data.cdnBaseUrl) {
            appConfig.cdnBaseUrl = `${resp.data.cdnBaseUrl}files/iptv/new/`
          }
          resolve(true)
        }).catch(e=>{
          Log.info('Get Cdn Path - ', e)
          resolve(true)
          //do not do any changes. /if any error we will fallback to the server url.
          //call the initializeApp
        })
      }).then(()=>{
        appConfig?.setupPath(appConfig?.platformSettings)
        initSettings(appConfig?.appSettings, appConfig?.platformSettings)
        initUtils({path: appConfig?.platformSettings.path})
        // const path = `${appConfig?.resouceUrl}splash-${appConfig?.siteId}.jpg`
        // Log.info('Splash Path:', path)
        // Log.info('Utils:', Utils.asset(''))
        // this.Background.patch({
        //   texture: Img(path).contain(1920, 1080)
        // })
        ApplicationInstance.application.loadFonts(platform.getFonts('')).then(()=>{
          bootResolve() 
        })
        
      })
    })
  },
  root: 'splash',
  routes: [
    {
      path: 'splash',
      component: Splash,
      widgets: ['LoadingScreen', 'Notification', 'Bookmark'],
    },
    {
      path: 'select-screen',
      component: SelectScreen,
      widgets: ['LoadingScreen', 'Notification', 'Dialog'],
    },
    {
      path: 'two-row-select-screen',
      component: TwoRowSelectScreen,
      widgets: ['Notification', 'Dialog'],
    },
    {
      path: 'main-grid-screen/:l1grid/:showLoading?',
      component: MainGrid,
      on(page: MainGrid, { l1grid, showLoading }) {
        return new Promise((resolve) => {
          if (showLoading == '1') {
            page.widgets.loadingscreen.showL1LoadingScreen(true)
          }
          const { appState } = AppData as AppSetup
          const app = appState?.getApp()!
          const reload = l1grid?.split('_')[1] == 'true' ? true : false
          const gridViewModel = app.loadL1(l1grid, reload)
          page.gridViewModel = gridViewModel
          app.initAdHandler();
          appState.gridMode=true;
          resolve()
        })
      },
      widgets: ['LoadingScreen', 'Menu', 'OptionsMenu', 'About', 'Notification', 'Bookmark', 'MoreInfo', 'Dialog', 'ParentalControl'],
    },
    {
      path: 'mlp-grid-screen/:id',
      component: MLPGrid,
      after(page: MLPGrid, { id }) {
        Log.info("mlp-grid-screen ",id);
        let _id = id;
        return new Promise((resolve) => {
          const { appState } = AppData as AppSetup
          const app = appState?.getApp()
          const parentGrid = app?.navigation.getCurrentGrid()
          const vodInfo = app?.navigation.getCurrentVodInfo()
          const gridViewModel = app?.loadShow(vodInfo, _id as string)
          page.gridViewModel = gridViewModel!
          appState.gridMode=true;
          resolve()
        })
      },
      widgets: ['LoadingScreen', 'OptionsMenu', 'About', 'Notification', 'MoreInfo', 'Dialog', 'ParentalControl'],
    },{
      path: 'mlp-grid-screen/similar/:id',
      component: MLPGrid,
      after(page: MLPGrid, { id }) {
        let _id = id?.split('_')[0];
        Log.info("mlp-grid-screen/similar ",_id);
        return new Promise((resolve) => {
          const { appState } = AppData as AppSetup
          const app = appState?.getApp()
          let parentGrid = app?.navigation.getCurrentGrid()
          if(parentGrid?.type == GRIDTYPE.SIMILAR_VIDEOS) {
            app?.navigation.pop()
          }
          const gridViewModel = app?.loadSimilarVideos(_id as string)
          app?.navigation.push(gridViewModel)
          page.gridViewModel = gridViewModel!
          appState.gridMode=true;
          resolve()
        })
      },
      widgets: ['LoadingScreen', 'OptionsMenu', 'About', 'Notification', 'MoreInfo', 'Dialog', 'ParentalControl'],
    },
    {
      path: "video-screen/:id",
      component: VideoScreenNew,
      widgets: ['LoadingScreen', 'Dialog', 'Notification']
    },
    {
      path: "video-screen-live/:id",
      component: VideoScreenLive,
      widgets: ['LoadingScreen', 'Dialog']
    },
    {
      path: "search-screen/:prevPage",
      component: SearchScreen,
      widgets: ['Notification', 'Dialog', 'Menu', 'Bookmark'],
      before(page: SearchScreen, { prevPage }) {
        return new Promise((resolve) => {
          page.prevPage = prevPage!
          resolve()
        })
      },
    },
    {
      path: "cc-setting/:prevPage",
      component: CCSetting,
      widgets: ['Notification'],
      before(page: CCSetting, { prevPage }) {
        return new Promise((resolve) => {
          page.prevPage = prevPage!
          resolve()
        })
      },
    },
    {
      path: "settings-screen/:prevPage",
      component: SettingsScreen,
      widgets: ['Notification', 'Menu', 'Dialog'],
      before(page: SettingsScreen, { prevPage }) {
        return new Promise((resolve) => {
          page.prevPage = prevPage!
          resolve()
        })
      },
    }
  ],
}
